import BracketView from './BracketView';
import MatchListView from './MatchListView';
import { isMatchList } from '../../utils/bracket';
import { getDivisionParticipants } from '../../utils/bracketSet';
import { useI18n } from '../../i18n';
import { translateDivisionLabel } from '../../i18n/labels';

function BracketSetView({
  bracketSet,
  editMode,
  selectedSwap,
  onSelectWinner,
  onSelectRound1Slot,
  onEditScore,
  liveMatches,
  onStartLive,
  onEndLive,
  divisions,
  participants,
  onChangeMatchList,
}) {
  const { t } = useI18n();
  if (!divisions?.length) {
    const emptyMessage =
      bracketSet?.mode === 'height'
        ? t('bracket.empty.height')
        : bracketSet?.mode === 'gender'
          ? t('bracket.empty.gender')
          : t('bracket.empty.default');
    return <p className="panel-empty bracket-division-empty">{emptyMessage}</p>;
  }

  return (
    <div className="bracket-set">
      {divisions.map(({ key, label, bracket }) => (
        <section key={key} className="bracket-division-section">
          {label && (
            <h3
              className={`bracket-division-title${key === 'M' ? ' male' : key === 'F' ? ' female' : ''}`}
            >
              {translateDivisionLabel(label)}
              <span className="bracket-division-size">
                {isMatchList(bracket)
                  ? t('bracket.matchCount', { count: bracket.bracketSize })
                  : t('bracket.bracketSize', { size: bracket.bracketSize })}
              </span>
            </h3>
          )}
          {isMatchList(bracket) ? (
            <MatchListView
              bracket={bracket}
              participants={getDivisionParticipants(bracketSet, key, participants)}
              editMode={editMode}
              onChange={
                onChangeMatchList ? (update) => onChangeMatchList(key, update) : undefined
              }
              onSelectWinner={
                onSelectWinner && !editMode
                  ? (roundIndex, matchIndex, player) =>
                      onSelectWinner(key, roundIndex, matchIndex, player)
                  : undefined
              }
              onEditScore={
                onEditScore && !editMode
                  ? (roundIndex, matchIndex) => onEditScore(key, label, roundIndex, matchIndex)
                  : undefined
              }
              liveMatches={editMode ? null : liveMatches?.filter((l) => l.divisionKey === key)}
              onStartLive={
                onStartLive && !editMode
                  ? (roundIndex, matchIndex) => onStartLive(key, roundIndex, matchIndex)
                  : undefined
              }
              onEndLive={editMode ? undefined : onEndLive}
            />
          ) : (
            <BracketView
              bracket={bracket}
              onSelectWinner={
                onSelectWinner
                  ? (roundIndex, matchIndex, player) =>
                      onSelectWinner(key, roundIndex, matchIndex, player)
                  : undefined
              }
              editMode={editMode}
              selectedSwapSlot={
                selectedSwap?.division === key ? selectedSwap.slot : null
              }
              onSelectRound1Slot={
                onSelectRound1Slot ? (slotIndex) => onSelectRound1Slot(key, slotIndex) : undefined
              }
              onEditScore={
                onEditScore
                  ? (roundIndex, matchIndex) => onEditScore(key, label, roundIndex, matchIndex)
                  : undefined
              }
              liveMatches={liveMatches?.filter((l) => l.divisionKey === key)}
              onStartLive={
                onStartLive
                  ? (roundIndex, matchIndex) => onStartLive(key, roundIndex, matchIndex)
                  : undefined
              }
              onEndLive={onEndLive}
            />
          )}
        </section>
      ))}
    </div>
  );
}

export default BracketSetView;
